<script setup lang="ts">
import Plus from '@/components/svg/Plus'
import Minus from '@/components/svg/Minus'

export default {
	components: { Plus, Minus },
  props: {
		question: { type: String, required: true },
		answer: { type: String, required: true },
		initialOpen: { type: Boolean },
  },
	data: (instance) => ({
		checked: !!instance.initialOpen,
	}),
}
</script>

<template>
	<label
		class="faq-item group py-5 px-8 transition-colors ease-out duration-100 cursor-pointer"
		:style="`background-color: ${checked ? 'white' : 'rgba(255, 255, 255, 0)'}`"
	>
		<input
			type="checkbox"
			v-model="checked"
			class="sr-only"
		/>
		<div class="flex justify-between items-center gap-8">
			<span
				:class="[
					'select-none text-lg font-medium leading-normal transition-colors ease-out duration-150',
					checked ? 'text-grey-700' : 'text-grey group-hover:text-grey-600',
				]"
			>{{ question }}</span>
			<div class="relative flex justify-center items-center w-5 h-5">
				<Minus
					v-if="checked"
					width="14"
					class="absolute"
					style="color: #9E141F;"
				/>
				<Plus
					v-else
					class="absolute w-5 text-grey group-hover:text-grey-600 transition-colors ease-out duration-150"
				/>
			</div>
		</div>
		<p
			:class="[
				'mt-2 text-grey text-base leading-normal tracking-wide select-none transition-opacity ease-out duration-100',
				!checked && 'sr-only opacity-0',
			]"
			v-html="answer"
		/>
	</label>
</template>

<style>
.faq-item p > a {
	font-weight: 500;
	text-decoration: underline;
}
</style>
